module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1529-d4269a002178c754617477d736757d4c.png";